module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsSAAALEgHS3X78AAAA0klEQVRIia3VsRHCIBiG4TdO4AS5dGndwBVsUhtHcZLEOo0ruIFtulwmcANsYgoCCOT7OuDgOX64+wtjDHbqYW6BarOQnmlsyr6wkQXoBMAvt4NjshICAJULmcQIm3LBWrILcIw85xxYuzuRlNTD3APXEOIqlxIAIBuJBbKRAPAAXruREDA2Zevak4TkAElILhCN7AGikL3AX0QBBBEV4EWUgBNRAxtEBHy8iPAGT2s8FcYYeYmWfnQC3muPr4fZ1VSy38CO7wvLAB8iBcDT49X5Aiiqe0jWYC5MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager/up_tick_icon.png
// module id = 8nZB
// module chunks = 0